export default function aboutController() {
    return "";
}
